import React from 'react';

import Footer from 'components/Footer/Footer';
import Grid, { allowedLayouts } from 'foundations/Grids/Grid';
import GridBlock from 'foundations/Grids/GridBlock';
import { main_links, site_links, section_links, social_links } from './links';


const styles = {
  standard: {
    background: '#fff',
    width: '100%',
  },
  productLanding: {
    background: '#eff0f3',
    width: '100%',
  },
  standardLanding: {
    background: '#f6f6f6',
    width: '100%',
  }
};


export const standardLayout = () => (
  <div style={styles.standard}>
    <Grid layout={allowedLayouts.full}>
      <GridBlock
        modifier={'MainContainer'}
      >
        <Footer supportLink={'/support'} />
      </GridBlock>
    </Grid>
  </div>
);

export const productLandingLayout = () => (
  <div style={ styles.productLanding }>
    <Grid layout={allowedLayouts.full}>
      <GridBlock
        modifier={'MainContainer'}
      >
        <Footer
          layout={'plp'}
          mainLinks={[
            {
              title: 'Help center',
              href: '/help'
            },
            {
              title: 'Visit Airtel.in',
              href: '/visit'
            },
            {
              title: 'Client area',
              href: '/visit'
            }
          ]}
          socialLinks={social_links} />
      </GridBlock>
    </Grid>
  </div>
);

export const standardLandingLayout = () => (
  <div style={styles.standardLanding}>
    <Grid layout={allowedLayouts.full}>
      <GridBlock modifier={'FullWidth'}>
        <Footer
          layout={'slp'}
          mainLinks={main_links}
          sectionLinks={section_links}
          socialLinks={social_links}
          siteLinks={site_links} />
      </GridBlock>
    </Grid>
  </div>
);




// WEBPACK FOOTER //
// ./src/containers/components/Footer/constants/footersLayouts.js